import { EditableText } from '@smartfire/components';
import { defineBlock, smartProps } from '@smartfire/js-block-engine';
import style from './block.module.scss';

function MenuItemEditor() {
    return <EditableText placeholder="Texte du menu" smartProp={'text'} className={style.block} />;
}

export default defineBlock({
    Block: MenuItemEditor,
    smartProps: {
        text: smartProps.string.withDefault(''),
    },
    setup: {
        title: 'Menu Item',
        parent: ['smartfire/mini-menu'],
    },
});
